import ClientService, {
  getHemisphereSessionToken,
  notifyHemisphereSessionExpired,

} from "./client-service";
import axios, { AxiosInstance } from "axios";
require("axios-debug-log");
require("axios-debug-log/enable");
class RGPDService extends ClientService {
  constructor() {
    super(process.env.VUE_APP_RGPD_URL, {
      headerProvider() {
        const headers: any = {
          "Content-Type": "application/json"
        };
        const token = getHemisphereSessionToken();
        if (token) {
          headers["Authorization"] = "Bearer " + token;
        }
        return headers;
      },
      deconnectionHandler() {
        notifyHemisphereSessionExpired();
      },
    });
  }
  getUserData() {
    return this.client.get(`/rgpdData/getUserData`);
  }

  getUserDataFiles() {
    return this.client.get(`/rgpdData/getUserDataFiles`);
  }

  async downloadFile(file_url: string) {
    const token = getHemisphereSessionToken();
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
    axios({
      url: file_url,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const fileURL = window.URL.createObjectURL(response.data);
      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      const file_name = file_url.split("/").pop()!
      fileLink.setAttribute("download", file_name);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    });
  }
}
const rgpdService = new RGPDService();

export default rgpdService;
